'use client';

import { cn } from '@/lib/ui/cn';

interface RadioOption {
  value: string;
  label: string;
}

interface RadioGroupProps {
  name: string;
  options: RadioOption[];
  value: string | undefined;
  onChange: (value: string) => void;
  error?: string;
}

/**
 * Vertical radio group with styled options.
 * Used for single-select steps like SignupType, Urgency, PcpStatus.
 */
export function RadioGroup({
  name,
  options,
  value,
  onChange,
  error,
}: RadioGroupProps) {
  return (
    <div className='flex flex-col gap-[12px]'>
      {options.map(option => {
        const isSelected = value === option.value;
        return (
          <label
            key={option.value}
            className={cn(
              'flex h-[56px] cursor-pointer items-center justify-start gap-[10px] rounded-[60px] border border-[#F1E6D6] bg-white px-[24px] py-[16px] transition-colors',
              isSelected && 'border-sh-sky bg-sh-sky/5'
            )}
          >
            <input
              type='radio'
              name={name}
              value={option.value}
              checked={isSelected}
              onChange={e => onChange(e.target.value)}
              className='sr-only'
            />
            {/* Custom radio indicator */}
            <div className='flex h-[24px] w-[24px] flex-shrink-0 items-center justify-center rounded-full border-2 border-[#292722]'>
              {isSelected && (
                <div className='h-[12px] w-[12px] rounded-full bg-[#292722]' />
              )}
            </div>
            <span className='font-sans text-[15px] leading-[20px] font-normal text-[#292722]'>
              {option.label}
            </span>
          </label>
        );
      })}
      {error && <p className='mt-1 text-sm text-red-500'>{error}</p>}
    </div>
  );
}
